import React from 'react';
import style from '../css/ChooseUs.module.css';
import { FaGlobeAsia, FaRegClock, FaHeadphonesAlt } from 'react-icons/fa';

function WhyChooseUs() {
	return (
		<section className={style.wrapper}>
			<div className={style.header}>
				<h2 className={style.mainTitle}>Why Choose Exporest</h2>
				<div className={style.subTitle}>
					<p className={style.emphasis}>
						Trusted Travel Experts with Global Reach
					</p>

					<span>
						Serving both corporate clients and individual travelers with
						reliability, value, and care.
					</span>
				</div>
			</div>
			<div className={style.cards}>
				{/* Global Network */}
				<div className={`${style.card} ${style.purple}`}>
					<FaGlobeAsia className={style.icon} />
					<h3 className={style.cardTitle}>
						End-to-End Global Travel Management
					</h3>

					<p className={style.cardText}>
						From domestic getaways to complex international itineraries, we
						coordinate every bookings — flights, hotels, cars, and more — all
						under one roof.
					</p>
				</div>
				{/* Fast Booking & Support */}
				<div className={`${style.card} ${style.white}`}>
					<FaRegClock className={style.icon} />
					<h3 className={style.cardTitle}>
						Fast, Flexible & Time-Saving Process
					</h3>

					<p className={style.cardText}>
						We leverage smart technology, live fares, and expert workflow to
						ensure fast booking turnarounds and zero delay in confirmations.
					</p>
				</div>
				{/* 24/7 Support */}
				<div className={`${style.card} ${style.green}`}>
					<FaHeadphonesAlt className={style.icon} />
					<h3 className={style.cardTitle}>
						24/7 Human Support You Can Rely On
					</h3>

					<p className={style.cardText}>
						Our travel support desk is available day and night — no bots, just
						real people solving real travel issues in real time.
					</p>
				</div>
			</div>
		</section>
	);
}

export default WhyChooseUs;
